module.exports = __webpack_public_path__ + "img/postback-step-8.ru.74280a18.jpg";